export abstract class Routes {
  public static readonly HOME = '/home';
  public static readonly EXCHANGE = '/exchange';
  public static readonly ADMIN = '/admin';

  public static readonly ADMIN_DASHBOARD = `${Routes.ADMIN}/dashboard/`;

  public static readonly PUBLISH_PROFILES = `${Routes.ADMIN}/publish/profiles`;

  public static readonly MANAGE_LIVE_EVENTS = `${Routes.ADMIN}/liveEvents/`;

  public static readonly PUBLISH_PROFILES_NEW_YOUTUBE = `${Routes.ADMIN}/publish/profiles/new/youtube`;
  public static readonly PUBLISH_PROFILES_EDIT_YOUTUBE = `${Routes.ADMIN}/publish/profiles/edit/youtube`;
  public static readonly PUBLISH_PROFILES_NEW_TWITTER = `${Routes.ADMIN}/publish/profiles/new/x`;
  public static readonly PUBLISH_PROFILES_EDIT_TWITTER = `${Routes.ADMIN}/publish/profiles/edit/x`;

  public static readonly PUBLISH_PROFILES_NEW_LAN = `${Routes.ADMIN}/publish/profiles/new/lan`;
  public static readonly PUBLISH_PROFILES_EDIT_LAN = `${Routes.ADMIN}/publish/profiles/edit/lan`;

  public static readonly PUBLISH_PROFILES_NEW_YAHOO = `${Routes.ADMIN}/publish/profiles/new/yahoo`;
  public static readonly PUBLISH_PROFILES_EDIT_YAHOO = `${Routes.ADMIN}/publish/profiles/edit/yahoo`;

  public static readonly VIRTUAL_CLIPPER = '/virtual-clipper';

  public static readonly TWITTER_TOKEN_VERIFICATION = '/twitter-token-verification';
}
